import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/farmtradedirect/src/app/sign-up-login-screen/components/AuthScreen.tsx");
